:host {
  display: block;
}

.m-card {
  &.m-card--gray {
    background-color: var(--BG-COLOR);
  }
}
